<template>
  <div id="ServiceTax" class="q-pa-md">
    <div class="text-h6 q-mx-md q-my-sm">{{ name }}</div>
    <div class="row">
      <div class="col-2 q-ma-sm " v-if="servicetax">
        <q-list class="buttons-list">
          <q-item
            v-for="item in servicetaxs"
            :key="item"
            clickable
            v-ripple
            :active="servicetax === item"
            @click="changeServiceTaxSelect(item)"
            active-class="itemSelect"
            class="item q-pa-md q-ma-sm shadow-1"
          >
            <q-item-section> {{ $gettext(item.nameBtn ? item.nameBtn : item.name) }}</q-item-section>
          </q-item>
        </q-list>
      </div>
      <q-card class="col-9 q-ma-md no-padding">
        <span v-for="item in servicetaxs" :key="item">
          <q-card-section v-if="servicetax === item" class="padding-crud">
            <crud-layout-search
              :ref="'crudLayoutSearch-' + item.name"
              :name="$gettext(item.name)"
              :interface="item.interface"
              :id="id"
              :page="item.page"
              :page-table="item.pageTable"
              clean-layout
            />
          </q-card-section>
        </span>
      </q-card>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'ServiceTax',
  components: {
    CrudLayoutSearch
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ServiceTax extends Vue {
  servicetaxs = [];
  servicetax = '';
  indice = 0;

  beforeMount () {
    this.servicetaxs = [
      {
        name: 'SERVICES_COST_CENTER',
        nameBtn: 'SERVICES_COST_CENTER_ABBREVIATED',
        interface: 'serviceCostCenter.pesquisar'
      },
      {
        name: 'SERVICE_TAX',
        interface: 'serviceTax.pesquisar'
      }
    ]
    this.servicetax = this.servicetaxs[0]
  }

  changeServiceTaxSelect (item) {
    this.servicetax = item
  }
}
export default ServiceTax
</script>
<style lang="stylus" scoped>
#ServiceTax {
  @import '~quasar-variables';

  .dataTableCrud {
    height: calc(65vh - 25px);
    box-shadow: none !important;
    padding: 0px;
  }

  ::v-deep {
    .jt-crud-container {
      padding: 0%;
    }
  }

  .padding-crud {
    padding: 0px 10px 10px;
    margin-top: -15px;
  }

  .itemSelect {
    color: white;
    background: $secondary !important;
    border-left: 5px solid $dark !important;
    padding-left: 5% !imporant;
  }

  .item {
    background: white;
    font-weight: 500;
    padding-left: 10%;
    font-size: 1rem;
  }
}
</style>
